export default __webpack_public_path__ + "static/media/closeButton.3e1f4a4c.svg";